import React, { useState, useEffect } from 'react';
import MieszkancyListaLista from './MieszkancyListaLista';
import MieszkancyUliceBox from './MieszkancyUliceBox';
import MieszkancyRodzajLokaluBox from './MieszkancyRodzajLokaluBox';

import { motion } from 'framer-motion';
import { wstepy } from '../../functions/motions';
const MieszkancyLista = (props) =>{

  const { mieszkancy, setMieszkaniec, udzialyKontaAkt, setEditDataOd, setEditDataDo, grupaUdzial, 
    setGrupaUdzial, setUser, grupy, wybraneGrupyUdzial, setWybraneGrupyUdzial, ulice, ulicaId, lokale, setUlicaId, setEditKonto, 
    mieszkaniec, bezdomni, setAddGrupe, rodzajLokalu, setRodzajLokalu, setWybranyOdczyt, users_w, state, setLoaderOn} = props;

  useEffect( () => {
    let grupyTemp = [];
    if (ulicaId > 0) {
      grupy?.forEach( g => {
        const lokal = lokale?.find( l => l.id == g?.id_lokal );
        if ( lokal?.rodzaj === rodzajLokalu && lokal?.ulica == ulicaId )
          grupyTemp.push(g)
      })
    }
    setWybraneGrupyUdzial(grupyTemp); 
  }, [ulicaId, grupy, mieszkancy, rodzajLokalu])

  return (
      <motion.div 
        className="content listaMieszkancow"
        variants={wstepy}
        initial="initial"
        animate="animate"
      >
          <MieszkancyUliceBox
            ulice={ulice}
            ulicaId={ulicaId}
            setUlicaId={setUlicaId}
            setMieszkaniec={setMieszkaniec}
            setUser={setUser}
            setGrupaUdzial={setGrupaUdzial}
            setAddGrupe={setAddGrupe}
            setWybranyOdczyt={setWybranyOdczyt}
            setLoaderOn={setLoaderOn}
          />
          <MieszkancyRodzajLokaluBox
            ulice={ulice}
            ulicaId={ulicaId}
            setMieszkaniec={setMieszkaniec}
            setUser={setUser}
            setGrupaUdzial={setGrupaUdzial}
            setEditKonto={setEditKonto}
            setAddGrupe={setAddGrupe}
            rodzajLokalu={rodzajLokalu}
            setRodzajLokalu={setRodzajLokalu}
            setWybranyOdczyt={setWybranyOdczyt}
            setLoaderOn={setLoaderOn}
          />
          <MieszkancyListaLista
            mieszkancy={mieszkancy}
            setMieszkaniec={setMieszkaniec}
            setEditDataOd={setEditDataOd}
            setEditDataDo={setEditDataDo}
            udzialyKontaAkt={udzialyKontaAkt}
            wybraneGrupyUdzial={wybraneGrupyUdzial}
            ulice={ulice}
            lokale={lokale}
            grupy={grupy}
            grupaUdzial={grupaUdzial}
            setGrupaUdzial={setGrupaUdzial}
            setUser={setUser}
            ulicaId={ulicaId}
            bezdomni={bezdomni}
            mieszkaniec={mieszkaniec}
            setAddGrupe={setAddGrupe}
            rodzajLokalu={rodzajLokalu}
            setWybranyOdczyt={setWybranyOdczyt}
            users_w={users_w}
            state={state}
            setLoaderOn={setLoaderOn}
          />
      </motion.div>
  )
}

export default MieszkancyLista;

